import { api } from './api';

export const dashboardApi = {
  getStats: () => api.get('/api/v1/admin/dashboard/stats'),
  getRecentActivity: () => api.get('/api/v1/admin/dashboard/recent-activity'),
  getAiCosts: (params) => api.get('/api/v1/admin/dashboard/ai-costs', params),
};
